'use strict';

var curve = exports;

curve.base = require('./base');
curve.short = require('./short');
curve.mont = require('./mont');
curve.edwards = require('./edwards');



//////////////////
// WEBPACK FOOTER
// ./~/elliptic/lib/elliptic/curve/index.js
// module id = 226
// module chunks = 10